module.exports = __webpack_public_path__ + "static/aws-architect-73f6dd412bb15cbc12236ad5bc1cf038.png";